<template>

	<div class="p_background">
		<div class="container_right_info">
			<div class="clearfix tb_padding">
				<div class="container_box">
					<h4 class="message_title">
			    		<span>基本信息</span>
			    	</h4>
					<section class="partition_message developer_box publick_form_box developer_basic_box">

						<!--手机号码-->
						<section class="form_box">
							<label class="form_label" for="">手机号码：</label>
							<span>{{tCloudUser.mobile}}</span>
						</section>

						<!--企业名称-->
						<section class="form_box">
							<label class="form_label" for="">企业名称：</label>
							<span>{{tCloudUserCompany.companyName}}</span>
						</section>

						<!--统一社会信用代码-->
						<section class="form_box">
							<label class="form_label" for="">统一社会信用代码：</label>
							<span>{{tCloudUserCompany.companyNo}}</span>
						</section>

						<!--联系地址-->
						<section class="form_box">
							<label class="form_label" for="">联系地址：</label>
							<span>{{tCloudUserCompany.sites}}</span>
						</section>

						<!--营业执照-->
						<section class="form_box">
							<label class="form_label" for="">营业执照：</label>
							<div class="example id_card_photo inline-block" id="images">
								<img :src="echoImg" alt="" class="zoomify img_default" title="营业执照" id="imgz" width="234px" />
							</div>
						</section>

						<!--认证情况-->
						<section class="form_box">
							<label class="form_label" for="">认证情况：</label>
							<span>【已认证】</span>
						</section>

					</section>
				</div>
				
				<div class="container_box">
					<h4 class="message_title">
			    		<span>结算方式</span>
			    	</h4>
			    	<section class="partition_message developer_box publick_form_box developer_basic_box">
						<!--开户行-->
						<section class="form_box">
							<label class="form_label" for="">开户行：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.bankType}}</span>
						</section>
						<!--开户支行-->
						<section class="form_box">
							<label class="form_label" for="">开户支行：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.bankBranch}}</span>
						</section>
						<!--卡号-->
						<section class="form_box">
							<label class="form_label" for="">银行卡号：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.cardNo}}</span>
						</section>
						<!--开户名-->
						<section class="form_box">
							<label class="form_label" for="">开户名：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.cardUsername}}</span>
						</section>
					</section>
				</div>
				
				<div class="container_box">
					<h4 class="message_title">
			    		<span>联系方式</span>
			    	</h4>

					<section class="partition_message developer_box publick_form_box developer_basic_box">

						<!--联系地址-->
						<section class="form_box">
							<label class="form_label" for="">联系地址：</label>
							<span>{{tCloudUserCompany.sites}}</span>
						</section>

						<!--联系人姓名-->
						<section class="form_box">
							<label class="form_label" for="">联系人姓名：</label>
							<span>{{tCloudUserCompany.companyContacts}}</span>
						</section>

						<!--电子邮箱-->
						<section class="form_box">
							<label class="form_label" for="">电子邮箱：</label>
							<span>{{tCloudUser.email}}</span>
						</section>

						<!--手机号码-->
						<section class="form_box">
							<label class="form_label" for="">手机号码：</label>
							<span>{{tCloudUser.mobile}}</span>
						</section>

						<!--其他号码-->
						<section class="form_box">
							<label class="form_label" for="">其它电话：</label>
							<span>{{tCloudUserCompany.companyPhone}}</span>
						</section>

						<!--QQ-->
						<section class="form_box">
							<label class="form_label" for="">QQ：</label>
							<span>{{tCloudUser.qq}}</span>
						</section>

						<!--官网地址-->
						<section class="form_box">
							<label class="form_label" for="">官网地址：</label>
							<span>{{tCloudUserCompany.companyUrl}}</span>
						</section>

					</section>
				</div>
				<!-- container_box/ -->

			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'company_data',
		data() {
			return {
				imgH: '',
				imgW: '',
				echoImg: '',
				tCloudUser: '',
				tCloudUserCompany: '',
				tCloudUserBankcard: ''
			}
		},
		created: function() {
			this.queryCompanyDeveloperInfo();
		},
		mounted: function() {
			this.imgFd();
		},
		computed: {

		},
		methods: {
			imgFd() {
				$('.example img').zoomify();
			},
			//获取个人信息
			queryCompanyDeveloperInfo() {
				var temp = this;
				this.$http.post('/zklccloud/queryCompanyDeveloperInfo', { emulateJSON: true }).then(function(m) {
					temp.tCloudUser = m.body.content.tCloudUser,
						temp.tCloudUserCompany = m.body.content.tCloudUserCompany,
						temp.tCloudUserBankcard = m.body.content.tCloudUserBankcard,
						temp.echoImg = m.body.content.tCloudUserCompany.companyBusinessLicense
				})
			},
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// company_data.vue?03fee3ad